__turbopack_context__.v({
  "className": "poppins_c4162cf2-module__D8k-8a__className",
  "variable": "poppins_c4162cf2-module__D8k-8a__variable",
});
